import React from 'react';
import { useNavigate } from "react-router-dom";

export default function Upload() {
    const navigate = useNavigate();
    const handleClick = (url) => {
        navigate(url + window.location.search)
    }

    return (
        <>
            <div className="container">
                <div className="uploadimage_content">
                    <div className="phot_head">
                        <h2>Download your <br /> photographs  <br/>taken with PM Modi.</h2>
                        <p style={{ marginBottom: '0' }}>View the available photos after scanning your face with your device's camera.</p>
                    </div>

                    <div className="uploadimage_box">
                        <ul>
                            {/* <li className="Smoothie">
                                <a href="#" onClick={() => handleClick("/upload/image")}>
                                    <img src="/assets/images/folder.svg" alt="" />
                                </a>
                                <h5>Drop image here, or browse</h5>
                                <p>Kindly upload a clear image of your face’s front view in .jpg or .png format.</p>
                            </li>
                            <li>
                                or
                            </li> */}
                            <li>
                                <a href="#" onClick={() => handleClick("/scan-youface")}>
                                    <img src="/assets/images/scanner2.svg" alt="" />
                                </a>
                                <h5>Scan your face</h5>
                                <h6>Scan your face from front using your device’s camera.</h6>
                                {/* <p style={{ marginTop: '15px', marginLeft: '0px', marginRight: '0px', maxWidth: '285px', fontSize: '13px' }}>Disclaimer: Photos will be available to download within 24 hours</p> */}
                                <p>Disclaimer: Photos will be available to download within 24 hours</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}